export enum ButtonType {
  CUSTOM = 'custom',
  FILES = 'file',
  TOGGLE = 'toggle',
  PANEL = 'panel',
  INLINE_PANEL = 'inline-panel',
  EXTERNAL_MODAL = 'external-modal',
  DROPDOWN = 'dropdown',
  SEPARATOR = 'separator',
  SIZE_ORIGINAL = 'size-original',
  SIZE_CONTENT_CENTER = 'size-content-center',
  SIZE_SMALL_CENTER = 'size-small-center',
  SIZE_SMALL_LEFT = 'size-small-left',
  SIZE_SMALL_RIGHT = 'size-small-right',
  ALIGN_LEFT = 'align-left',
  ALIGN_RIGHT = 'align-right',
  ALIGN_CENTER = 'align-center',
  SIZE_CONTENT = 'size-content',
  SIZE_FULL_WIDTH = 'size-full-width',
  SIZE_SMALL = 'size-small',
  SIZE_MEDIUM = 'size-medium',
  SIZE_LARGE = 'size-large',
  TEXT_ALIGN_LEFT = 'alignment-left',
  TEXT_ALIGN_CENTER = 'alignment-center',
  TEXT_ALIGN_RIGHT = 'alignment-right',
  WIDTH = 'width',
  HEIGHT = 'height',
  LINK = 'link',
  SPOILER = 'spoiler',
  DELETE = 'delete',
  LINK_PREVIEW = 'link-preview',
  VIDEO_SETTINGS = 'video-settings',
  FILE_UPLOAD_SETTINGS = 'file-upload-settings',
  AUDIO_SETTINGS = 'audio-settings',
}

export enum ModifierKey {
  COMMAND = 'command',
  CTRL = 'ctrl',
  OPTION = 'option',
  SHIFT = 'shift',
  ALT = 'alt',
}

export enum ToolbarType {
  SIDE = 'SIDE',
  MOBILE = 'MOBILE',
  FOOTER = 'FOOTER',
  STATIC = 'STATIC',
  INLINE = 'INLINE',
  PLUGIN = 'PLUGIN',
  FORMATTING = 'FORMATTING',
  INSERT_PLUGIN = 'INSERT_PLUGIN',
  TEXT = 'ALL-TEXT-TOOLBARS',
  SHORTCUT = 'SHORTCUT',
  LINK = 'LINK',
  EXTERNAL = 'EXTERNAL',
  PLUGIN_MENU = 'PLUGIN_MENU',
  MEGA = 'MEGA',
  EMPTY = 'EMPTY',
}

export enum DisplayMode {
  NORMAL = 'NORMAL',
  FLOATING = 'FLOATING',
}

export enum DecorationMode {
  PREPEND = 'PREPEND',
  WRAP = 'WRAP',
  APPEND = 'APPEND',
}
